import { PowerSyncDatabase } from '../../../db/PowerSyncDatabase.js';
import { AbstractWebPowerSyncDatabaseOpenFactory } from '../AbstractWebPowerSyncDatabaseOpenFactory.js';
import { WASQLiteOpenFactory } from './WASQLiteOpenFactory.js';
/**
 * @deprecated {@link PowerSyncDatabase} can now be constructed directly
 * @example
 * ```typescript
 * const powersync = new PowerSyncDatabase({database: {
 *  dbFileName: 'powersync.db'
 * }});
 * ```
 */
export class WASQLitePowerSyncDatabaseOpenFactory extends AbstractWebPowerSyncDatabaseOpenFactory {
    openDB() {
        const factory = new WASQLiteOpenFactory(this.options);
        return factory.openDB();
    }
    generateInstance(options) {
        return new PowerSyncDatabase(options);
    }
}
